export default "__VITE_ASSET__Dn0$s5WN__"